<template>
  <form @submit.prevent>
    <div class="row">
      <div class="col-12">
        <fg-input type="text"
          placeholder="Name"
          :class="{ 'form-group--error': $v.name.$error }"
          v-model="$v.name.$model">
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <fg-input type="text"
          placeholder="AWS Product Key"
          :class="{ 'form-group--error': $v.awsProductKey.$error }"
          v-model="$v.awsProductKey.$model">
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <fg-input type="text"
          placeholder="AWS Checksum Key"
          :class="{ 'form-group--error': $v.awsChecksumKey.$error }"
          v-model="$v.awsChecksumKey.$model">
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p-button type="info"
          :loading="isSaving"
          @click.native.prevent="save">
          <span v-if="!download">Create</span>
          <span v-else>Save</span>
        </p-button>
      </div>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { notify } from '../../services/notify';

export default {
  name: 'DownloadForm',
  props: {
    version: Object,
    download: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      name: "",
      awsProductKey: "",
      awsChecksumKey: "",
      isSaving: false
    }
  },
  validations: {
    name: { required },
    awsProductKey: { required },
    awsChecksumKey: { }
  },
  created() {
    if (this.download) {
      this.name = this.download.name || "";
      this.awsProductKey = this.download.aws_product_key || "";
      this.awsChecksumKey = this.download.aws_checksum_key || "";
    }
  },
  methods: {
    async save() {
      this.$emit('clearSuccess');
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error(`Please provide download details.`)
        return;
      }

      let download = {
        name:             this.name,
        aws_product_key:  this.awsProductKey,
        aws_checksum_key: this.awsChecksumKey
      };

      this.isSaving = true;
      let success = false;
      if (!this.download) {
        download.product_version_id = this.version.id;
        success = await this.$store.dispatch('product/createDownload', download);
      } else {
        download.id = this.download.id;
        success = await this.$store.dispatch('product/updateDownload', download);
      }
      this.isSaving = false;

      if (success) {
        this.$emit('hasUpdate');
      }
    }
  }
};
</script>
